import { Typography } from "@mui/material";

const TypographyCustom = (props) => {
  const { fontFamily = "メイリオ", ...restProps } = props;

  return <Typography fontFamily={fontFamily} {...restProps}></Typography>;
};

export default TypographyCustom;
